import { useStaticQuery, graphql } from "gatsby"
import { useCallback } from "react"

import { DEFAULT_STOREFRONT } from "../../../cart/constants"

interface storyBlokBundle {
  uuid: string
  content: string
  full_slug: string
}

export const useGetStoryblokBundle = () => {
  const data = useStaticQuery(graphql`
    query StoryblokBundles {
      allStoryblokEntry(
        filter: { full_slug: { regex: "/settings/bundles/" } }
      ) {
        edges {
          node {
            uuid
            content
            full_slug
          }
        }
      }
    }
  `)

  return useCallback(
    (
      id: string,
      queryBy: "id" | "code" | "slug" = "id"
    ): Storyblok.BundleConfig | null => {
      const bundle = data.allStoryblokEntry.edges.find(
        (bundle: { node: storyBlokBundle }) => {
          if (queryBy === "slug") {
            return bundle.node.full_slug === id
          } else if (queryBy === "code") {
            const content = JSON.parse(bundle.node.content)
            return (
              content.code === id && content.storefront === DEFAULT_STOREFRONT
            )
          } else {
            return bundle.node.uuid === id
          }
        }
      )

      if (bundle) {
        return { uuid: bundle.node.uuid, ...JSON.parse(bundle.node.content) }
      }

      return null
    },
    [data]
  )
}
